<template>
  <div class="color-letters-avatar" :class="{'color-letters-avatar_bordered': border}">
    <img v-if="userHasAvatar" :src="user.imageUrl" alt="avatar">
    <div v-else class="color-letters-avatar__no-avatar" :style="{'background-color': color}">
      {{ initials }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ColorLettersAvatar',
    props: {
      user: null,
      border: {
        type: Boolean,
        default: true,
      },
      color: String,
    },
    computed: {
      emptyUser () {
        return !this.user?.id
      },
      userHasAvatar () {
        return !!this.user?.imageUrl
      },
      initials () {
        if (this.emptyUser) {
          return ''
        }
        let initials = ''

        if (this.user.firstName) {
          initials += this.user.firstName.substring(0, 1).toUpperCase()
        }
        if (this.user.lastName) {
          initials += this.user.lastName.substring(0, 1).toUpperCase()
        }

        return initials
      },
    },
  }
</script>

<style lang="less" scoped>
.color-letters-avatar {
  width: 50px;
  height: 50px;
  background-color: #00000008;
  border-radius: 50%;
  flex-shrink: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;

  &_bordered {
    border: 4px solid #fff;
  }

  &__no-avatar {
    background: #FF9100;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 300;
    font-size: 13px;
    text-transform: uppercase;
  }

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  svg {
    width: 100%;
    height: 100%;
  }

  /* &:nth-child(2) {
     margin-top: 10px;
   }*/
}
</style>
